export default "__VITE_ASSET__Ez69H4XY__"